export default [
    "create_account","documents_verification","call_verification","create_portfolio"
];

